// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"4530b9a4","279":"25a9492f","641":"9675e539","893":"ca6851fd"}[chunkId] + ".chunk.css";
};